<template>
	<div class="home">
		<!--视频播放器开始-->
		<Vplayer :datainfo="currentVideo" :isShow="isShow" @close="onClose" v-if="!!currentVideo"></Vplayer>
		<!--视频播放器结束-->
		<!--<Nav/>-->
		<changeNav />
		<Carousel :isShow="iscShow" />
		<!--产品与服务开始-->
		<section class="product">
			<div class="product_title">
				<img src="~@/assets/image/Products_solutions.png" width="120" height="23" alt="" class="title_img" />
				<span class="productTxt">Products & solutions</span>
				<a class="allLink" @click="goPeoductDetail()">全部
					<img src="~@/assets/image/icon_04@2x(1).png" alt="" width="7" height="10" class="allArrow" />
				</a>
			</div>
			<el-row :gutter="20">
				<el-col :span="8" v-for="(item,index) in  ProServices" :key=index>
					<div class="grid-content bg-purple">
						<ProductItem :info=item :current=item.id />
					</div>
				</el-col>
			</el-row>
		</section>
		<!--产品与服务结束-->

		<!--新闻动态开始-->
		<section class="dynamic_new">
			<div class="dynamic_container">
				<el-container>
					<el-header class="dynamic_title">
						<img src="~@/assets/image/newCenter.png" alt="" class="title_img" width="96" height="23" />
						<span class="dynamic_newTxt">News Center</span>
					</el-header>
					<el-main class="dynamic_box">
						<el-container>
							<el-aside width="600px">
								<el-image :src="DynamicImageurl" lazy style="width: 600px;height: 360px">
									<div slot="placeholder" class="image-slot">
										<!-- <img src="~@/assets/image/news_information_null.png" alt="" width="600" height="306" class="" /> -->
										<img src="" alt="" width="600" height="306" class="" />
									</div>
									<div slot="error" class="image-slot">
										<!-- <img src="~@/assets/image/news_information_null.png" alt="" width="600" height="306"> -->
										<img src="" alt="" width="600" height="306">
									</div>
								</el-image>
								<div class="news_item clearfix" @click="goNewDetail(DynamicFrist.id)">
									<div class="data_mark">
										<div class="day">{{DynamicFrist.newsDate | data("DAY") }}</div>
										<div class="year_mon">{{DynamicFrist.newsDate |data("YEARMON")}}</div>
									</div>
									<div class="birf_info">
										<div class="brif_Title">{{DynamicFrist.title}}</div>
										<div class="brif_con">
											{{DynamicFrist.content}}
										</div>
									</div>
								</div>
							</el-aside>
							<el-main class="new_list">
								<div class="news_item clearfix" v-for="(item, index) in DynamicRest" :key="index" @click="goNewDetail(item.id)">
									<div class="data_mark">
										<div class="day">{{item.newsDate| data("DAY")}}</div>
										<div class="year_mon">{{item.newsDate | data("YEARMON")}}</div>
									</div>
									<div class="birf_info">
										<div class="brif_Title">{{item.title}}</div>
										<div class="brif_con">
											{{item.content}}
										</div>
									</div>
								</div>
							</el-main>
						</el-container>
					</el-main>
					<el-footer class="dynamic_more">
						<el-button round class="more_btn" @click="goDynamicDetail()">MORE ></el-button>
					</el-footer>
				</el-container>
			</div>
		</section>
		<!--新闻动态结束-->

		<!--项目成果动态开始-->
		<section class="achievements">
			<div class="achieve_container">
				<el-row :gutter="20">
					<el-col :span="7" class="achieve_item">
						<div class="grid-content bg-purple">
							<div class="font_achieveT">2018<sub>年</sub></div>
							<div class="text_theme">公司成立时间</div>
						</div>
					</el-col>
					<!-- <el-col :span="4" class="achieve_item">
						<div class="grid-content bg-purple">
							<div class="font_achieveT">1582<sub>万</sub></div>
							<div class="text_theme">服务用户</div>
						</div>
					</el-col>
					<el-col :span="4" class="achieve_item">
						<div class="grid-content bg-purple">
							<div class="font_achieveT">324<sub style="right: 40px">+</sub></div>
							<div class="text_theme">专家团队</div>
						</div>
					</el-col> -->
					<el-col :span="7" class="achieve_item">
						<div class="grid-content bg-purple">
							<div class="font_achieveT">60<sub style="right: 50px">+</sub></div>
							<div class="text_theme">合作客户</div>
						</div>
					</el-col>
					<el-col :span="7" class="achieve_item">
						<div class="grid-content bg-purple">
							<div class="font_achieveT">50<sub style="right: 40px">+</sub></div>
							<div class="text_theme">项目研究成果</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</section>
		<!--项目成果动态开始-->
		<!--品牌故事开始-->
		<section class="brand_story">
			<div class="brand_story_container">
				<el-container>
					<el-aside width="414">
						<img src="~@/assets/image/yszn.jpg" width="414" height="274" alt="" class="story_img" />
					</el-aside>
					<el-main>
						<el-container>
							<div class="story_band_container">
								<el-header>
									<img src="~@/assets/image/brand_story.png" alt="" class="img_title" width="95" height="23" />
									<span class="title_txt">About US</span>
								</el-header>
								<el-main>成立于2018年2月1日，是一家专业的工业智能化系统工程设备提供商。公司自创立起，便致力于智能化物流管控称重系统、智能化自动配料系统、全生产工艺动态模拟显示和集中操作、数据采集管理等方面，积累了丰富的经验，完成了多项大型DCS、PCS系统工程及配料自控工程。通过艰苦摸索，深入挖掘，我们成功开发了大型养殖客户自动喂料系统、上市涂料客户智能助剂系统、央企冶金客户智能视觉系统，截至2021年2月，公司拥有越盛智能喂料称重管理系统V1.0、智能提货管理系统V1.0、越盛板面质量检测系统V1.0等多项软件著作权。</el-main>
								<el-footer>
									<el-button round class="story_detail" @click="goToAboutUs()">了解详情</el-button>
								</el-footer>
							</div>
						</el-container>
					</el-main>
				</el-container>
			</div>
		</section>
		<!--品牌故事结束-->
		<!--视频宣传开始-->
		<section class="videopro">
			<div class="videopro_container">
				<el-container>
					<el-header class="head_title">
						<img src="~@/assets/image/videoimg.png" alt="" class="img_title" width="96" height="23" />
						<span class="title_txt">Video promotion</span>
						<a class="allLink" @click="goVideo()">全部
							<img src="~@/assets/image/icon_04@2x(1).png" alt="" width="7" height="10" class="allArrow" />
						</a>
					</el-header>
					<el-main>
						<el-row :gutter="12">
							<el-col :span="6" v-for="(item,index) in videoPromotion" :key=index>
								<div class="grid-content bg-purple video_play" @click="playVideo(item,index)">
									<el-container>
										<el-header class="video_img">
											<!--<img :src="item.imageUrl"  width="300" height="166" alt=""/>-->
											<el-image :src="item.imageUrl" lazy style="width: 300px;height: 166px">
												<div slot="placeholder" class="image-slot">
													<!-- <img src="~@/assets/image/video_publicity_null.png" alt="" width="300" height="166" class="" /> -->
													<img src="" alt="" width="300" height="166" class="" />
												</div>
												<div slot="error" class="image-slot">
													<!-- <img src="~@/assets/image/video_publicity_null.png" alt="" width="300" height="166"> -->
													<img src="" alt="" width="300" height="166">
												</div>
											</el-image>
											<div class="video_mark">
												<img src="~@/assets/image/video_play.png" alt="" width="49" height="49">
											</div>
										</el-header>
										<el-main class="video_txt">
											{{item.title}}
										</el-main>
									</el-container>
								</div>
							</el-col>
						</el-row>
					</el-main>
				</el-container>
			</div>
		</section>
		<!--视频宣传结束-->

		<!--精英团队开始-->
		<!-- <section class="team">
			<div class="team_container">
				<el-container>
					<el-header class="head_title">
						<img src="~@/assets/image/team.png" alt="" class="img_title" width="96" height="23" />
						<span class="title_txt">Team</span>

						<a class="allLink" @click="goTeamAll">全部
							<img src="~@/assets/image/icon_04@2x(1).png" alt="" width="7" height="10" class="allArrow" />
						</a>
					</el-header>
					<el-main>
						<div class="team_list">
							<ul class="team_list_container clearfix">
								<li class="team_item" v-for="(item,index) in teamList" :key="index">
									<div class="header">
										<div class="avator">
											<el-image :src="item.imageUrl" lazy style="width: 180px;height: 180px">
												<div slot="placeholder" class="image-slot">
													<img src="~@/assets/image/Team_Elite_null.png" alt="" width="300" height="380" class="" />
												</div>
												<div slot="error" class="image-slot">
													<img src="~@/assets/image/Team_Elite_null.png" alt="" width="300" height="380">
												</div>
											</el-image>
										</div>
									</div>
									<div class="info_content">
										<div class="introl"> <span class="name">{{item.name}}</span> <span class="positon_txt">{{item.title}}</span></div>
										<div class="content"> {{item.content}} </div>
									</div>
									<div class="el-footer">
										<el-button round class="person_detail" @click="goTeamDetail(item.id)">了解详情</el-button>
									</div>
								</li>
							</ul>
						</div>
					</el-main>
				</el-container>
			</div>
		</section> -->
		<!--精英团队结束-->

		<!--资质证书开始-->
		<section class="honor">
			<div class="honor_container">
				<el-container>
					<el-header class="head_title">
						<img src="~@/assets/image/honor.png" alt="" class="img_title" width="96" height="23" />
						<span class="title_txt">HONOR</span>
					</el-header>
					<el-main>
						<HonorCarousel />
					</el-main>
				</el-container>
			</div>
		</section>
		<!--资质证书结束-->

		<!--加入我们开始-->
		<section class="join_uS">
			<div class="join_us_container">
				<el-container>
					<el-header class="head_title">
						<img src="~@/assets/image/join_us.png" alt="" class="img_title" width="96" height="23" />
						<span class="title_txt">Join US</span>
					</el-header>
					<el-main>
						<div class="join_us_bg">
							<el-button round class="join_uS_detail" @click="goToJoinUsDetail()">了解详情</el-button>
							<Joincarousel />
						</div>
					</el-main>
				</el-container>
			</div>
		</section>
		<!--加入我们结束-->


		<!--我们的客户开始-->
		<section class="Customer">
			<div class="Customer_container">
				<el-container>
					<el-header class="head_title" style="margin-bottom: 10px;">
						<img src="~@/assets/image/Customer.png" alt="" class="img_title" width="96" height="23" />
						<span class="title_txt">Partners</span>
					</el-header>
					<el-main class="customer_main">
						<el-row :gutter="15">
							<el-col :span="4.1" v-for="(item,index) in customerList" :key=index>
								<div class="grid-content bg-purple">
									<el-container>
										<el-header class="Customer_img">
											<!--<img :src="item.imageUrl"  width="232" height="129" alt=""/>-->
											<el-image :src="item.imageUrl" lazy style="width: 232px;height: 129px">
												<div slot="placeholder" class="image-slot">
													<!-- <img src="~@/assets/image/Team_Elite_null.png" alt="" width="232" height="192" class="" /> -->
													<img src="" alt="" width="232" height="192" class="" />
												</div>
												<div slot="error" class="image-slot">
													<!-- <img src="~@/assets/image/Team_Elite_null.png" alt="" width="232" height="192"> -->
													<img src="" alt="" width="232" height="192">
												</div>
											</el-image>
										</el-header>
										<el-header class="customer_name">
											<div>{{item.name}}</div>
										</el-header>
									</el-container>
								</div>
							</el-col>
						</el-row>
					</el-main>
				</el-container>
			</div>
		</section>
		<!--我们的客户结束-->

		<!--联系我们-->
		<section class="contact clearfix">
			<div class="contact_container">
				<div class="contact_text">
					<div class="contactUs">
						<el-header>
							<img src="~@/assets/image/contactUs.png" alt="" class="img_title" width="96" height="23" />
							<span class="title_txt">Contact US</span>
						</el-header>
					</div>
					<div class="company_name_container clearfix">
						<div class="company_icon"><img src="~@/assets/image/icon_08.png" alt="" class="img_icon" width="48" height="46" /></div>
						<div class="company_name">
							<div class="company_cname">福建省越盛智能科技有限公司</div>
							<div class="company_ename">Fujian Yuesheng Intelligent Technology Co., Ltd.</div>
						</div>

					</div>

					<div class="info_contact">
						<img src="~@/assets/image/icon_09.png" alt="" class="img_icon" width="16" height="16" />
						<span>福建省福州市马尾区铁北路8号YKO工业园2号楼4层</span>
					</div>
					<!-- <div class="info_contact">
						<img src="~@/assets/image/icon_10.png" alt="" class="img_icon" width="16" height="16" />
						<span>zhbgs@fnpsy.com</span>
						<span>dkhb@fnpsy.com</span>
					</div> -->
					<div class="info_contact">
						<img src="~@/assets/image/icon_11.png" alt="" class="img_icon" width="16" height="16" />
						<span>15059117433</span>
					</div>
					<div class="info_contact">
						<img src="~@/assets/image/icon_15.png" alt="" class="img_icon" width="16" height="16" />
						<span>595782964</span>
					</div>
					<div class="info_contact">
						<img src="~@/assets/image/icon_16.png" alt="" class="img_icon" width="16" height="16" />
						<span>0591-83970405</span>
					</div>
					<div class="info_contact">
						<!-- <div class="focus_us">关注我们</div> -->

						<!-- <div class="img_icon_sina">
							<a href="https://weibo.com/u/1685334741" target="_blank" style="width: 100%; height: 100%; display: block"></a>
						</div>
						<div class="img_icon_wx" @mouseenter="showCode" @mouseleave="hideCode"></div>
						<Wxhover :direction="direction" :allCode="allCode" :postionStyle="true" /> -->
						
						<img src="~@/assets/image/wexincode.jpg" alt="" class="img_title" width="160" height="160" />
					</div>
				</div>
				<div class="contact_map">
					<!-- <MapView class="map_container" :mapInfo="mapInfo" /> -->
					<img src="~@/assets/image/map.png" class="map_container" />
				</div>
			</div>
		</section>

		<!--联系我们结束-->
		<!--底部开始-->
	</div>
</template>

<script>
	import MapView from '@/components/MapView.vue';
	import FooterView from '@/components/Footer.vue';
	import ProductItem from '@/components/ProductItem.vue';
	import Carousel from '@/components/Carousel.vue';
	import Joincarousel from '@/components/Joincarousel.vue';
	import HonorCarousel from '@/components/HonorCarousel.vue';
	import changeNav from '@/components/changeNav.vue';
	import Vplayer from '@/components/Vplayer.vue';
	import Wxhover from '@/components/Wxhover';
	import {
		GetPServicesList,
		GetNewsDynamicList,
		GetVideoPromotionList,
		GetTeamList,
		GetCustomerList
	} from './Home.model';

	export default {
		name: 'home',
		components: {
			MapView,
			FooterView,
			ProductItem,
			Carousel,
			Joincarousel,
			HonorCarousel,
			Vplayer,
			changeNav,
			Wxhover
		},
		metaInfo: {
			title: '福建省越盛智能科技有限公司', // set a title
			meta: [{ // set meta
				name: '越盛智能、全自动智能布料小车、无功补偿、无人值守智能称重、视觉智能检测、能源在线监测、智能配料、自动喂料系统、自动喂养系统、智能饲养系统、养猪场喂料设备、养鸡场自动喂料系统、自动化养殖设备、智能喂养系统、智能称重喂养系统、自动称重喂养设备',
				content: '首页'
			}],
			link: [{ // set link
				rel: 'asstes',
				href: 'http://www.fjyszn.com/'
			}]
		},
		data() {
			return {
				isShow: false,
				ProServices: [],
				DynamicData: [],
				DynamicImageurl: "",
				DynamicFrist: {},
				DynamicRest: [],
				videoPromotion: [],
				teamList: [],
				customerList: [],
				mapInfo: {
					position: {
						lng: 119.412585,
						lat: 26.032594
					},
					zoom: 19,
					tip: '',
					dragg: false
				},
				reqData: {
					limit: 10,
					page: 1,
				},
				list: [],
				currentVideo: null,
				currItem: null,
				currentNav: "Nav",
				iscShow: true,
				direction: "bottom",
				allCode: false
			}
		},
		async mounted() {
			let param = {
				page: 1,
				limit: 6
			};
			let DynamicParam = {
				page: 1,
				limit: 4
			};
			let customerParam = {
				page: 1,
				limit: 10
			};
			const newServices = await GetPServicesList({"page" : 1, "limit" : 3});
			this.ProServices = newServices.data.list;
			const DynamicNews = await GetNewsDynamicList(DynamicParam);
			this.DynamicData = DynamicNews.data.list;
			this.DynamicFrist = DynamicNews.data.list[0];
			this.DynamicImageurl = this.DynamicFrist.imageUrl;
			this.DynamicRest = DynamicNews.data.list.slice(1);
			const videodata = await GetVideoPromotionList(DynamicParam);
			this.videoPromotion = videodata.data.list;
			//const teamListData = await GetTeamList(DynamicParam);
			//this.teamList = teamListData.data.list;
			const customerData = await GetCustomerList(customerParam);
			this.customerList = customerData.data.list;


		},
		methods: {
			goToJoinUsDetail() {
				this.$router.push({
					path: "/joinUs"
				});
			},
			goToAboutUs() {
				this.$router.push({
					path: "/aboutus"
				});
			},
			goDynamicDetail() {
				this.$router.push({
					path: "/dynamic"
				});
			},
			goNewDetail(newId) {
				this.$router.push({
					path: '/NewDetail',
					query: {
						plan: newId
					}
				});
			},
			goTeamAll() {
				this.$router.push({
					path: '/Team'
				});
			},
			goTeamDetail(teamId) {
				this.$router.push({
					path: '/TeamDetail',
					query: {
						teamId: teamId
					}
				})
			},
			goPeoductDetail(teamId) {
				this.$router.push({
					path: '/product'
				})
			},
			goVideo() {
				this.$router.push({
					path: '/propaganda'
				});
			},
			playVideo(item, index) {
				this.currItem = item;
				this.isShow = true;
				this.currentVideo = this.currItem;
			},
			onClose() {
				this.isShow = false
			},
			showCode() {
				this.allCode = true;
			},
			hideCode() {
				this.allCode = false;
			}
		}
	}
</script>
<style lang="less" scoped>
	.product,
	.dynamic_container,
	.achieve_container {
		width: 1240px !important;
		margin: 0px auto;
	}

	.product {
		margin-top: 90px;
		margin-bottom: 50px;

		.el-col {
			height: 415px;
			margin-bottom: 20px;
		}

		.product_title {
			text-align: left;
			vertical-align: bottom;
			color: #ccc;
			font-size: 16px;
		}

		.productTxt {
			margin: 14px 0px 0px 14px;
		}

		.title_img {
			vertical-align: bottom;
		}

		;

		.allLink {
			text-align: right;
			float: right;
			font-size: 14px;
			margin-top: 8px;
			color: #999;
			position: relative;
			font-weight: 400;
			cursor: pointer;

			&:hover {
				text-decoration: none;
			}
		}

		.grid-content {
			margin-top: 22px;
			height: 480px;
		}
	}

	.dynamic_new {
		width: 100%;
		background: rgba(242, 242, 242, 1);

		.dynamic_title {
			text-align: left;
			vertical-align: bottom;
			color: #ccc;
			font-size: 16px;
			padding: 50px 0px 0px 0px;
			height: 105px !important;
		}

		.dynamic_newTxt {
			margin: 14px 0px 0px 14px;
		}

		.title_img {
			vertical-align: bottom;
		}

		.dynamic_box {
			padding: 0px;

			.news_item {
				width: 600px;
				color: #999;
				cursor: pointer;

				.data_mark {
					float: left;
					width: 68px;
					height: 70px;
					border: 1px solid rgba(204, 204, 204, 1);
					margin-top: 40px;

					.day {
						font-size: 30px;
					}

					.year_mon {
						line-height: 16px;
						font-size: 12px;
						font-weight: 400;
						color: rgba(153, 153, 153, 1);
						line-height: 16px;
					}
				}

				.birf_info {
					width: 512px;
					float: right;
					text-align: left;
					padding: 40px 0px 40px 0px;

					.brif_Title {
						height: 22px;
						font-size: 16px;
						font-weight: 500;
						color: rgba(51, 51, 51, 1);
						line-height: 25px;
						overflow: hidden;
						/*超出部分隐藏*/
						white-space: nowrap;
						/*不换行*/
						text-overflow: ellipsis;
						/*超出部分文字以...显示*/
					}

					.brif_con {
						width: 512px;
						height: 52px;
						font-size: 14px;
						font-weight: 400;
						color: rgba(153, 153, 153, 1);
						line-height: 24px;
						margin-top: 4px;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2; //这里是在第二行有省略号
						overflow: hidden;
					}

				}
			}
		}

		.new_list {
			position: relative;
			padding-left: 40px;
			padding-right: 0px;

			.news_item {
				border-bottom: 1px solid #ccc;
			}

			&::before {
				content: '';
				height: 1px;
				width: 600px;
				position: absolute;
				top: 1px;
				left: 40px;
				background-color: #ccc;
			}
		}

		.dynamic_more {
			height: 110px !important;

			.more_btn {
				margin-top: 18px;
				/*width:135px;*/
				/*height:42px;*/
				/*border-radius:21px;*/
				/*border:none;*/
				text-align: center;
				width: 135px;
				height: 42px;
				border-radius: 21px;
				border: 1px solid rgba(204, 204, 204, 1);
				background: rgba(242, 242, 242, 1) !important;

				&:hover {
					background: #39B2EC;
					color: #fff;
					cursor: pointer;
					border: none;
					background: linear-gradient(45deg, rgba(57, 178, 236, 1) 0%, rgba(82, 233, 237, 1) 100%) !important;
				}
			}
		}
	}


	.achievements {
		height: 360px;
		background: #39B2EC;
		background: linear-gradient(45deg, rgba(40, 165, 231, 1) 0%, rgba(107, 218, 252, 1) 100%);
		color: #fff;

		.font_achieveT {
			font-size: 44px;
			font-weight: 600;
			position: relative;

			sub {
				vertical-align: bottom;
				font-size: 14px;
				position: absolute;
				top: 30px;
				right: 24px;
			}
		}

		.text_theme {
			font-weight: 400;
			color: #fff;
			line-height: 18px;
		}

		.achieve_item {
			height: 60px;
			color: #fff;
			text-align: center;
			margin: 60px 20px 0px;
			position: relative;

			&::after {
				content: "";
				display: block;
				width: 1px;
				height: 60px;
				position: absolute;
				right: -22px;
				top: 0px;
				background-color: #fff;
			}

			&:last-child::after {
				display: none;
			}
		}
	}

	.brand_story {
		position: relative;
		height: 200px;
		background-color: #F5F5F5;
		text-align: left;

		.brand_story_container {
			width: 1200px;
			margin: 0 auto;
			background-color: #fff;
			position: absolute;
			top: -160px;
			left: 50%;
			margin-left: -620px;
			padding: 20px;

			box-shadow: 0px 75px 35px -50px rgba(0, 0, 0, 0.1);

			.el-container {
				overflow: hidden;
			}

			.el-main {
				padding: 0px;
				color: #999;
				font-size: 14px;
				line-height: 24px;
				margin-top: 20px;
				padding-right: 20px;
			}
		}

		.story_band_container {
			margin-left: 40px
		}

		.el-footer {
			height: 80px !important;
		}

		.story_detail {
			width: 102px;
			height: 34px;
			line-height: 8px;
			border-radius: 17px;
			background-color: #FFF;
			color: #B3B3B3;
			float: right;
			margin-top: 30px;

			&:hover {
				color: #fff;
				background-color: #39B2EC;
				cursor: pointer;
				background: linear-gradient(45deg, rgba(40, 165, 231, 1) 0%, rgba(107, 218, 252, 1) 100%);
				box-shadow: 0px 9px 14px -8px rgba(57, 178, 236, 0.6);
			}
		}

	}

	/*标题公共样式*/
	.el-header {
		padding-top: 10px;
		height: 35px !important;
		padding-left: 0px;
	}

	.head_title {
		text-align: left;
		margin-bottom: 20px;
	}

	.img_title {
		vertical-align: middle;
	}

	.title_txt {
		font-size: 16px;
		color: #ccc;
		vertical-align: middle;
		margin-left: 10px;
	}

	.brand_story,
	.videopro,
	.team {
		background-color: #F2F2F2;
	}


	.videopro {
		height: 300px;

		.allLink {
			text-align: right;
			float: right;
			font-size: 14px;
			margin-top: 13px;
			color: #999;
			position: relative;
			font-weight: 400;
			cursor: pointer;

			&:hover {
				text-decoration: none;
			}
		}

		.el-main {
			padding: 0;
			text-align: center;
			overflow: hidden;
		}

		.el-header {
			height: 35px !important;
		}

		.video_img {
			height: 166px !important;
			padding-top: 0px;
			position: relative;

			&:hover {}
		}

		.video_txt {
			font-size: 14px;
			font-weight: 400;
			color: rgba(102, 102, 102, 1);
			line-height: 18px;
			text-align: center;
			margin-top: 10px;
		}
	}

	.videopro_container {
		.el-col {
			transform: rotate(0deg);
			-ms-transform: rotate(0deg);
			/* IE 9 */
			-moz-transform: rotate(0deg);
			/* Firefox */
			-webkit-transform: rotate(0deg);
			/* Safari 和 Chrome */
			-o-transform: rotate(0deg);
			/* Opera */
			transition: transform 1s;
			-moz-transition: transform 1s;
			/* Firefox 4 */
			-webkit-transition: transform 1s;
			/* Safari 和 Chrome */
			-o-transition: transform 1s;

			/* Opera */
			&:hover {
				cursor: pointer;

				.el-image {
					/*transform:rotate(4deg);*/
					/*-ms-transform:rotate(4deg); 	!* IE 9 *!*/
					/*-moz-transform:rotate(4deg); 	!* Firefox *!*/
					/*-webkit-transform:rotate(4deg); !* Safari 和 Chrome *!*/
					/*-o-transform:rotate(4deg); 	!* Opera *!*/
					transition: transform .5s;
					-moz-transition: transform .5s;
					/* Firefox 4 */
					-webkit-transition: transform .5s;
					/* Safari 和 Chrome */
					-o-transition: transform .5s;
					/* Opera */
				}
			}
		}

		.video_play {
			position: relative;

			.video_img {
				&:hover {
					.video_mark {
						display: block;
					}
				}
			}

			.video_mark {
				position: absolute;
				text-align: center;
				top: 0px;
				right: 0px;
				bottom: 0px;
				width: 100%;
				background: rgba(0, 0, 0, 0.5);
				line-height: 200px;
				display: none;
			}
		}

	}

	.contact_container,
	.Customer_container,
	.videopro_container,
	.team_container,
	.honor_container,
	.join_us_container,
	.contact_container {
		width: 1240px;
		margin: 0 auto;
	}

	/*团队精英*/
	.team {
		padding-bottom: 40px;
	}

	.team_container {
		.team_list_container {
			padding-top: 10px;
			width: 1260px;
			padding-bottom: 10px;
		}

		.head_title {
			margin-bottom: 12px;
		}

		.allLink {
			text-align: right;
			float: right;
			font-size: 14px;
			margin-top: 13px;
			color: #999;
			position: relative;
			font-weight: 400;
			cursor: pointer;

			&:hover {
				text-decoration: none;
			}
		}

		.team_item {
			width: 295px;
			height: 460px;
			margin-right: 20px;
			overflow: hidden;
			float: left;
			background-color: #fff;
			.header {
				width: 295px;
				height: 208px;				
			}

			.avator {
				width: 180px;
				height: 180px;
				border-radius: 50%;
				overflow: hidden;
				margin: 28px auto;
				.el-image{
					width: 180px;
					height: 180px;
					border-radius: 50%;
					overflow: hidden;
				}
			}

			&:hover {
				box-shadow: 0px 3px 16px 1px rgba(0, 0, 0, 0.1);
				transform: translateY(-10px);
				transition: transform 1s;
				-moz-transition: transform 1s;
				/* Firefox 4 */
				-webkit-transition: transform 1s;
				/* Safari 和 Chrome */
				-o-transition: transform 1s;

				/* Opera */
				.person_detail {
					background-color: #39B2EC;
					color: #fff;
					cursor: pointer;
					background: linear-gradient(45deg, rgba(40, 165, 231, 1) 0%, rgba(107, 218, 252, 1) 100%);
					box-shadow: 0px 9px 14px -8px rgba(57, 178, 236, 0.6);
					border: none;
				}
			}

		}

		.el-image {
			overflow: visible;
		}

		.el-col {
			border: 1px solid green;
			overflow: visible;
		}

		.el-main {
			padding: 0;
			text-align: center;
			overflow: hidden;

			.el-header {
				height: 380px !important;
				padding: 0px;
			}
		}

		.info_content {
			padding:0 12px;
			background-color: #fff;
		}

		.el-footer {
			background-color: #fff;
			margin-bottom: 20px;
			height: 40px;
		}

		.introl {
			line-height: 18px;
			color: #333;
			font-size: 14px;

			.name {
				width: 100%;
				text-align: center;
				font-size: 20px;
				display: block;
				line-height: 24px;
				font-weight: bolder;
				margin-bottom: 12px;
			}

			.positon_txt {
				display: block;
				width: 100%;
				text-align: center;
				font-size: 15px;
				line-height: 18px;
				height: 18px;
				text-overflow: ellipsis;
				white-space: nowrap;
				overflow: hidden;
			}

		}

		.content {
			font-size: 14px;
			margin-top: 16px;
			height: 48px;
			color: #999;
			line-height: 24px;
			text-overflow: -o-ellipsis-lastline;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			line-clamp: 2;
			-webkit-box-orient: vertical;
			text-align: center;
		}

		.el-main {
			color: #999;
			font-size: 14px;
			font-weight: 400;
			color: rgba(153, 153, 153, 1);
			line-height: 24px;
			text-align: left;
		}
		.el-footer{
			width: 100%;
			text-align: center;
		}
		.person_detail {
			display: block;
			width: 102px;
			height: 34px;
			line-height: 8px;
			border-radius: 17px;
			margin: 32px auto 0;
			border: 1px solid rgba(230, 230, 230, 1);

			&:hover {}
		}
	}

	/*资质证书*/
	.honor {
		height: 410px;
		background-color: #F2F2F2;

		.el-main {
			padding: 0px;
		}

	}

	/*加入我们*/
	.join_uS {
		height: 550px;
		background-color: #F2F2F2;

		.el-main {
			padding: 0px;
		}

		.join_us_bg {
			height: 448px;
			background: url("~@/assets/image/joinus_bg.png") no-repeat;
			background-size: 100% 100%;
			position: relative;

			.join_uS_detail {
				position: absolute;
				top: 270px;
				left: 78px;
				width: 135px;
				height: 42px;
				border-radius: 21px;
				border: 1px solid #fff;
				color: #fff;
				background-color: rgba(255, 255, 255, 0);

				&:hover {
					background-color: #39B2EC;
					color: #fff;
					cursor: pointer;
					background: linear-gradient(45deg, rgba(57, 178, 236, 1) 0%, rgba(82, 233, 237, 1) 100%);
					border: none;
				}
			}

		}
	}

	/*客户*/
	.Customer {
		background-color: #F2F2F2;

		.el-main {
			padding: 0;
			text-align: center;
			overflow: hidden;
			margin-bottom: 30px;
		}

		.el-header {
			height: 35px !important;
		}

		.Customer_img {
			height: 129px !important;
			padding-top: 0px;
			background-color: #fff;
		}

		.customer_name{
			font-size: 16px;
			text-align:center;
			font-weight:500;
			color:rgba(51,51,51,1);
			line-height:22px;
			margin-top: 5px;
			margin-bottom: 5px;
		}

		.customer_main {

			.el-row {}
		}
	}

	.Customer_container {
		.el-header {
			padding: 0;
		}

		.el-col {
			transform: rotate(0deg);
			-ms-transform: rotate(0deg);
			/* IE 9 */
			-moz-transform: rotate(0deg);
			/* Firefox */
			-webkit-transform: rotate(0deg);
			/* Safari 和 Chrome */
			-o-transform: rotate(0deg);
			/* Opera */
			transition: transform 1s;
			-moz-transition: transform 1s;
			/* Firefox 4 */
			-webkit-transition: transform 1s;
			/* Safari 和 Chrome */
			-o-transition: transform 1s;
			/* Opera */
			margin-bottom: 20px;
			height: 159px;

			&:hover {
				cursor: pointer;

				.el-image {
					transform: rotate(4deg);
					-ms-transform: rotate(4deg);
					/* IE 9 */
					-moz-transform: rotate(4deg);
					/* Firefox */
					-webkit-transform: rotate(4deg);
					/* Safari 和 Chrome */
					-o-transform: rotate(4deg);
					/* Opera */
					transition: transform .5s;
					-moz-transition: transform .5s;
					/* Firefox 4 */
					-webkit-transition: transform .5s;
					/* Safari 和 Chrome */
					-o-transition: transform .5s;
					/* Opera */
				}
			}
		}
	}

	/*联系我们*/
	.contact {
		padding: 50px 0 50px 0px;
		background-color: #FFF;
		color: #999;
		font-size: 14px;
		text-align: left;

		.contactUs {
			margin-bottom: 40px;
		}

		.company_name_container {
			.company_icon {
				float: left;
			}

			.company_name {
				float: left;
				margin-left: 16px;
			}

			.company_cname {
				font-size: 22px;
				font-weight: 400;
				color: rgba(153, 153, 153, 1);
				line-height: 24px;
			}

			.company_ename {
				margin-top: 3px;
				font-size: 14px;
				font-weight: 400;
				color: rgba(204, 204, 204, 1);
			}
		}

		.contact_text {
			float: left;

			.info_contact {
				margin-top: 20px;
				position: relative;
			}

			.img_icon {
				vertical-align: middle;
			}

			span {
				vertical-align: middle;
				margin-left: 20px;
			}

			.focus_us {

				font-size: 16px;
				font-weight: 500;
				color: rgba(51, 51, 51, 1);
				line-height: 20px;
				margin-bottom: 18px;
				padding-top: 30px;
			}

			.img_icon_sina {
				cursor: pointer;
				margin-right: 24px;
				width: 40px;
				height: 40px;
				display: inline-block;
				background: url("~@/assets/image/icon_12.png") no-repeat center center;
				background-size: cover;

				&:hover {
					cursor: pointer;
					background: url("~@/assets/image/icon_12_hover.png") no-repeat center center;
					background-size: cover;
				}
			}

			.img_icon_wx {
				width: 40px;
				height: 40px;
				display: inline-block;
				cursor: pointer;
				background: url("~@/assets/image/icon_13.png") no-repeat center center;
				background-size: cover;

				&:hover {
					cursor: pointer;
					background: url("~@/assets/image/icon_13_hover.png") no-repeat center center;
					background-size: cover;
				}
			}
		}

		.contact_map {
			float: right;
		}
	}


	.map_container {
		height: 430x;
		width: 736px;
		background-color: #ccc;
		margin: 0 auto;
	}
</style>
